import { useState, useCallback } from "react";
import type { HelpChatMessage } from "../../ai/aiApi";
import { runHelpChat } from "../../ai/aiApi";

const WELCOME_MESSAGE: HelpChatMessage = {
  role: "assistant",
  content:
    "Olá! Sou o assistente de ajuda do **AJA2 AI**. Estou aqui para responder a qualquer dúvida sobre a plataforma.\n\nPode perguntar, por exemplo:\n- Como criar um orçamento?\n- O cliente é obrigatório?\n- Como importar um mapa de quantidades?\n- Como funciona a análise de documentos técnicos?",
};

export function useHelpChat() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState<HelpChatMessage[]>([WELCOME_MESSAGE]);
  const [isLoading, setIsLoading] = useState(false);

  const toggle = useCallback(() => setIsOpen((v) => !v), []);
  const close = useCallback(() => setIsOpen(false), []);

  const sendMessage = useCallback(
    async (text: string) => {
      if (!text.trim() || isLoading) return;

      const userMsg: HelpChatMessage = { role: "user", content: text.trim() };
      const updatedMessages = [...messages, userMsg];
      setMessages(updatedMessages);
      setIsLoading(true);

      try {
        const history = updatedMessages.slice(-10); // last 10 messages for context
        const res = await runHelpChat({ message: text.trim(), conversationHistory: history });
        setMessages((prev) => [
          ...prev,
          { role: "assistant", content: res.reply },
        ]);
      } catch {
        setMessages((prev) => [
          ...prev,
          {
            role: "assistant",
            content: "Ocorreu um erro ao processar a sua pergunta. Tente novamente.",
          },
        ]);
      } finally {
        setIsLoading(false);
      }
    },
    [messages, isLoading],
  );

  return { isOpen, toggle, close, messages, isLoading, sendMessage };
}
